import {
  QUERY_PARAMS_SHIFT_LEFT,
  QUERY_PARAMS_SHIFT_RIGHT,
  QUERY_PARAMS_ZOOM_OUT,
  SET_QUERY_AGGREGATION_LEVEL,
  SET_QUERY_PARAMS,
  SHIFT_QUERY_PARAMS,
  UPDATE_QUERY_PARAMS
} from '../constants/actionTypes';
import { aggregationLevelToSeconds } from '../actions/queryParams';

const initialState = {
  from: null,
  to: null,
  aggregationLevel: null,
  aggregationLevelSeconds: null
};

const deltaT = state => Math.round(state.to - state.from);
const zoomOut = state => ({
  from: Math.round(state.from - deltaT(state) / 2),
  to: Math.round(state.to + deltaT(state) / 2)
});

const queryParams = (state = initialState, action) => {
  switch (action.type) {
    case SET_QUERY_PARAMS:
      const aggregationLevelSeconds = action.payload.aggregationLevel
        ? {
            aggregationLevelSeconds: aggregationLevelToSeconds(
              action.payload.aggregationLevel
            )
          }
        : null;

      return {
        ...state,
        ...action.payload,
        aggregationLevelSeconds
      };

    case SHIFT_QUERY_PARAMS:
      return {
        from: state.from + action.payload.from,
        to: state.to + action.payload.to,
        aggregationLevel: action.payload.aggregationLevel,
        aggregationLevelSeconds: aggregationLevelToSeconds(
          action.payload.aggregationLevel
        )
      };

    case QUERY_PARAMS_SHIFT_LEFT:
      return {
        ...state,
        from: state.from - deltaT(state),
        to: state.to - deltaT(state)
      };

    case QUERY_PARAMS_SHIFT_RIGHT:
      return {
        ...state,
        from: state.from + deltaT(state),
        to: state.to + deltaT(state)
      };

    case QUERY_PARAMS_ZOOM_OUT:
      return {
        ...state,
        ...zoomOut(state)
      };

    case UPDATE_QUERY_PARAMS:
      const newQueryParams = {};

      if (action.payload.from) {
        newQueryParams.from = action.payload.from;
      }

      if (action.payload.to) {
        newQueryParams.to = action.payload.to;
      }

      if (action.payload.aggregationLevel !== null) {
        newQueryParams.aggregationLevel = action.payload.aggregationLevel;
        newQueryParams.aggregationLevelSeconds = aggregationLevelToSeconds(
          action.payload.aggregationLevel
        );
      }

      return {
        ...state,
        ...newQueryParams
      };

    case SET_QUERY_AGGREGATION_LEVEL:
      return {
        ...state,
        aggregationLevel: action.payload.aggregationLevel,
        aggregationLevelSeconds: aggregationLevelToSeconds(
          action.payload.aggregationLevel
        )
      };

    default:
      return state;
  }
};

export default queryParams;



// WEBPACK FOOTER //
// ./src/redux/queryParams.js